import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentry';
import { handleStaleBundleError, installStaleBundleGuard } from './lib/stale-bundle-guard';
import App from './App';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CRMProvider } from './contexts/CRMContext';
import { PortalProvider } from './contexts/PortalContext';

// Initialize error tracking before anything else so early bootstrap errors
// (provider crashes, lazy import failures) are still captured.
initSentry();
installStaleBundleGuard();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      onError={handleStaleBundleError}
      fallback={<div style={{ padding: 24, fontFamily: 'system-ui' }}>Algo salió mal. Recarga la página.</div>}
    >
      <AuthProvider>
        <ThemeProvider>
          <PortalProvider>
            <CRMProvider>
              <App />
            </CRMProvider>
          </PortalProvider>
        </ThemeProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
